import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["submitButton", "cancelButton", "statusMessage", "fileInput"];

  submit() {
    if (!this.hasFileInputTarget || !this.fileInputTarget.files.length) {
      return;
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.innerHTML = `
        <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
        ${this.submitButtonTarget.dataset.loadingText || "Importiert..."}
      `;
    }

    if (this.hasCancelButtonTarget) {
      this.cancelButtonTarget.disabled = true;
      this.cancelButtonTarget.classList.add("disabled");
    }

    if (this.hasStatusMessageTarget) {
      this.statusMessageTarget.classList.remove("d-none");
      this.statusMessageTarget.classList.add("d-flex");
    }
  }
}
